import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-exam-rules',
  templateUrl: './exam-rules.component.html',
  styleUrls: ['./exam-rules.component.scss']
})
export class ExamRulesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
